import { render } from "./Training.vue?vue&type=template&id=0bdd6f42"
import script from "./Training.vue?vue&type=script&lang=js"
export * from "./Training.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__